import { render, staticRenderFns } from "./CompetitionViews.vue?vue&type=template&id=3984089c"
import script from "./CompetitionViews.vue?vue&type=script&lang=js"
export * from "./CompetitionViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports